<template>
  <div>
    <div class="wrapper"> 
      <NavigationTemplate v-if="token" :key="reRenderRoute" />  
      <div v-bind:class="[token ? 'content-page': '' ]">
        <div class="content">  
          <notifications
            group="foo-css" 
            :speed="500"
            :width="280"
            :height="30"
            animation-name="v-fade-left"
            position="top right"
          /> 
          <notifications
            group="foo-info" 
            :speed="500"
            :width="280"
            :height="30"
            animation-name="v-fade-left"
            position="top left"
          /> 
          <!-- Custom style example -->
          <notifications
            group="custom-style"
            position="top center"
            classes="n-light"
            :max="3"
            :width="400"
          /> 
          <!-- Custom template example -->
          <notifications
            group="custom-template"
            :duration="5000"
            :width="500"
            animation-name="v-fade-left"
            position="top left"
          > 
          </notifications> 
          <!-- Full width example -->
          <notifications
            group="full-width"
            width="100%"
          />
          <router-view v-slot="{ Component }" :key="$route.path">
            <topbarTemplate v-if="token" />
            <FadeInOut entry="left" exit="right" :duration="300" mode="out-in">
              <component :is="Component" />
            </FadeInOut>
          </router-view>
        </div>
      </div>
    </div> 
  </div>
</template>

<script> 
import NavigationTemplate from './NavigationTemplate.vue'
import topbarTemplate from './TopbarTemplate.vue'
import {mapGetters} from "vuex"; 
import {getCurrentInstance } from "vue";
export default {
  name: 'MasterTemplate',
  props: {
    msg: String
  },
  data() {
    return {
      isLogin:false,
      user:[]
    }
  },
  components: {
    NavigationTemplate,
    topbarTemplate
  },
  computed:{
    currentRouteName() {
      return this.$route.name;
    },
      ...mapGetters([
        'userData',
        'token',
      ]), 
  },
  created() {
    console.log("re-render-route", this.reRenderRoute);
    const api_url = this.apiUrl;
    const auth_headers = {
      headers: {
        'Authorization' : this.token ? `Bearer ${this.token}` : "",
        'Content-Type': 'application/json' 
      }
    };
    if(this.token) {
      const app = getCurrentInstance();
      app.appContext.config.globalProperties.headers = {headers: {
        'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
        'Content-Type': 'multipart/form-data' 
      }};

      app.appContext.config.globalProperties.headerjson = {headers: {
        'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
        'Content-Type': 'application/json' 
      }};
      //this.$store.dispatch('getUserMenuAndPermissions', {api_url, auth_headers});
    }
  },
  
}
</script>